/**
 * current element
 * @type {undefined}
 */
exports.currentEle = undefined;

/**
 * elements of vim.js app
 * @type {undefined}
 */
exports.boxes = undefined;

/**
 * app config
 * @type {undefined}
 */
exports.config = undefined;

/**
 * Router instance
 * @type {undefined}
 */
exports.router = undefined;

/**
 * Vim instance
 * @type {undefined}
 */
exports.vim = undefined;

/**
 * TextUtil instance
 * @type {undefined}
 */
exports.textUtil = undefined;

/**
 * clipboard of app
 * @type {undefined}
 */
exports.clipboard = undefined;

/**
 * app do list
 * @type {Array}
 */
exports.doList = [];

/**
 * app do list deep
 * @type {number}
 */
exports.doListDeep = 100;

/**
 * previous key code
 * @type {undefined}
 */
exports.prevCode = undefined;

exports.prevCodeTime = 0;

/**
 * numerical for vim command
 * @type {string}
 * @private
 */
exports._number = '';

/**
 * key codes white list of vim
 * @type {Array}
 */
exports.key_code_white_list = [];




/*****************
 ** WEBPACK FOOTER
 ** ./src/instance/app/init.js
 ** module id = 12
 ** module chunks = 0
 **/